import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { InputComponent } from '../input/input.component';
import { CommonService } from '../../services/common.service';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterModule, ButtonComponent, InputComponent, TranslateModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  forgotPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });
  isLoading = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private authService: AuthService,
    private commonService: CommonService
  ) {
  }

  onSubmit() {
    this.forgotPasswordForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.forgotPasswordForm)
    if (this.forgotPasswordForm.valid) {
      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';
      const { email } = this.forgotPasswordForm.value;
      if(!email) return
      this.authService.forgotPassword(email).subscribe(
        (response) => {
          this.isLoading = false;
          this.successMessage = response.message ?? 'Se han enviado las instrucciones a tu correo electrónico. Si no ves el correo, revisa la carpeta de spam';
        },
        (error) => {
          console.error('Error al solicitar recuperación de contraseña:', error);
          this.isLoading = false;
          this.errorMessage = error.error.message ?? 'Error al procesar la solicitud. Por favor, inténtalo de nuevo.';
        }
      );
    }
  }
}
